export const WriteRight = 'WEB_MODULE_SETTINGS_SUBSCRIPTIONS_WRITE'
export const Rights = [
    WriteRight
]
